// extracted by mini-css-extract-plugin
module.exports = {"paper":"search_main_snippet_card-module__paper--3asDr"};